import React from "react";
import { useLang } from "../context/LanguageContext";

const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`flex items-center gap-2 text-[13px] text-neutral-400 ${className}`}>
      <button
        onClick={() => setLang("sv")}
        className={lang === "sv" ? "text-white font-medium" : "hover:text-white transition-colors"}
      >SV</button>
      <span className="text-neutral-600">/</span>
      <button
        onClick={() => setLang("en")}
        className={lang === "en" ? "text-white font-medium" : "hover:text-white transition-colors"}
      >EN</button>
    </div>
  );
};

export default LanguageSwitcher;
